import compose from 'react-hooks-compose'

import { useUsuarioPageMainLogic } from './useLogic'
import { UsuarioPageMainPresenter } from './presenter'

export const UsuarioPageMain = compose(props => ({
	useLogic: () => useUsuarioPageMainLogic(props),
}))(UsuarioPageMainPresenter)
